export default __webpack_public_path__ + "static/media/FZHei.d52c05d8.ttf";